export default __webpack_public_path__ + "static/hero-4fd7298ae1d30c62c57a07500549c71c.png";